import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
export type ThemeId = 'dark' | 'light' | 'color';
const STORAGE_KEY = 'agentpopulation:theme';
interface ThemeContextValue {
  theme: ThemeId;
  setTheme: (t: ThemeId) => void;
}
const ThemeContext = createContext<ThemeContextValue | null>(null);
function isTheme(v: unknown): v is ThemeId {
  return v === 'dark' || v === 'light' || v === 'color';
}
function readStored(): ThemeId | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return isTheme(v) ? v : null;
  } catch {
    return null;
  }
}
export function ThemeProvider({
  initial,
  children
}: {
  initial: ThemeId;
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState<ThemeId>(() => readStored() ?? initial);
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* storage unavailable */
    }
  }, [theme]);
  const value = useMemo(() => ({
    theme,
    setTheme
  }), [theme]);
  return <ThemeContext.Provider value={value} data-id="element-867" data-mp="3r56csp9kkc1q">{children}</ThemeContext.Provider>;
}
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}